exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout{position:relative}.layout:before{content:\"\";position:fixed;display:block;top:0;left:0;width:100%;height:100%;background-size:cover;background-position:top;-webkit-transform:translateZ(0);transform:translateZ(0);will-change:transform;z-index:-1000}.flex-section{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;z-index:-100}.flex-section section{width:100%}@media (max-width:576px){.flex-section section:first-child{-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2}.flex-section section:nth-child(2){-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}.flex-section section:nth-child(3){-webkit-box-ordinal-group:4;-webkit-order:3;-ms-flex-order:3;order:3}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-311ab623","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Index/layout.vue
// module id = 85
// module chunks = 0